import { render } from "./NavBar.vue?vue&type=template&id=79dfb142&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__